import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { ModificationRequestDescriptor } from './model/modification.request';

@Injectable()
export class ModificationRequestService extends RESTServiceBase {

  constructor(
    private authService: AuthService,
    private config: AppConfig,
  ) {
    super(
      'v1',
      'ModificationRequestManagement',
      authService,
      config.CMSConfig
    );
  }

  public create(request: ModificationRequestDescriptor): Promise<string> {
    return super.post<string>(
      new ModificationRequestDescriptor({
        id: undefined,
        href: undefined,
        dataEntryId: request.dataEntryId,
        organizationId: undefined,
        formId: undefined,
        submittedBy: undefined,
        submittedOn: undefined,
        modificationRequestState: request.modificationRequestState,
        modified: undefined,
        deleted: undefined
      }));
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public getModificationRequests(view?: View): Promise<List<ModificationRequestDescriptor>> {
    return super.get<List<ModificationRequestDescriptor>>(undefined, view);
  }

  public getById(id: string): Promise<ModificationRequestDescriptor> {
    return super.get<ModificationRequestDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/modification.request/modification.request.service.ts